// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1zPKe","header":"Messages_header__1M3m1"};